exports.AgGridReact = require('./lib/agGridReact').AgGridReact;
exports.AgGridColumn = require('./lib/agGridColumn').AgGridColumn;



//////////////////
// WEBPACK FOOTER
// ./~/ag-grid-react/main.js
// module id = 1947
// module chunks = 0